//GeneratorFlag:[NoChange]
import LetterTopic from './letter-topic';

export default {LetterTopic}
export{LetterTopic}